import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/CallForAction'

export const CALL_FOR_ACTION_REQUEST_ASYNC = createAsyncTypes(
  'CALL_FOR_ACTION_REQUEST',
  'AwarenessCenter/CallForAction'
)

export const PAGINATE_CHANGE = `${typeKey}/PAGINATE_CHANGE`
export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SEARCH_RESET = `${typeKey}/SEARCH_RESET`

export const COPY_CALL_FOR_ACTION_ASYNC = createAsyncTypes('COPY_CALL_FOR_ACTION', typeKey)
export const DELETE_CALL_FOR_ACTION_ASYNC = createAsyncTypes('DELETE_CALL_FOR_ACTION', typeKey)
